(function () {
  function canStore() {
    try {
      window.localStorage.setItem('cm-test', '1');
      window.localStorage.removeItem('cm-test');
      return true;
    } catch (error) {
      return false;
    }
  }

  function initPopup(popup) {
    if (!popup || popup.dataset.initialized === 'true') return;
    popup.dataset.initialized = 'true';

    if (window.Shopify && window.Shopify.designMode) return;

    var storageAllowed = canStore();
    var storageKey = 'claymoreEmailPopupDismissedAt';
    var delay = Number(popup.dataset.delaySeconds || 8) * 1000;
    var showOnceDays = Number(popup.dataset.showOnceDays || 14);
    var expiresAfter = showOnceDays * 24 * 60 * 60 * 1000;
    var dialog = popup.querySelector('.cm-email-popup__dialog');
    var form = popup.querySelector('form');

    if (storageAllowed) {
      var dismissedAt = Number(window.localStorage.getItem(storageKey) || 0);
      if (dismissedAt && Date.now() - dismissedAt < expiresAfter) return;
    }

    function rememberDismissal() {
      if (storageAllowed) {
        window.localStorage.setItem(storageKey, String(Date.now()));
      }
    }

    function openPopup() {
      popup.hidden = false;
      window.requestAnimationFrame(function () {
        popup.classList.add('is-visible');
        document.documentElement.classList.add('cm-email-popup-open');
        if (dialog) dialog.focus();
      });
    }

    function closePopup() {
      rememberDismissal();
      popup.classList.remove('is-visible');
      document.documentElement.classList.remove('cm-email-popup-open');
      window.setTimeout(function () {
        popup.hidden = true;
      }, 220);
    }

    popup.querySelectorAll('[data-claymore-popup-close]').forEach(function (button) {
      button.addEventListener('click', closePopup);
    });

    popup.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') closePopup();
    });

    if (form) {
      form.addEventListener('submit', rememberDismissal);
    }

    window.setTimeout(openPopup, delay);
  }

  function initAllPopups(root) {
    (root || document).querySelectorAll('[data-claymore-email-popup]').forEach(initPopup);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAllPopups(document);
    });
  } else {
    initAllPopups(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAllPopups(event.target);
  });
})();
